import loadSessionModule from './modules/Session.module';
const loadShopNumberModule = () => ({
    hasRouter: false,
    modules: [loadSessionModule()],
});
export default loadShopNumberModule;
